import Vue from 'vue';
import moment from 'moment';

import alice from '../../alice-api';

function extractContent(content) {
  const finalContent = [];
  let tempDate = 0;
  let tempDateObj = null;
  for (let i = 0; i < content.length; i += 1) {
    if (content[i].created_at > tempDate) {
      const currentDateObj = moment(content[i].created_at, 'x');
      if (tempDateObj) {
        if (!currentDateObj.isSame(tempDateObj, 'day')) {
          finalContent.push({
            type: 'date-separator',
            id: `date-${currentDateObj.format('D-MMM')}`,
            date: currentDateObj.format('D MMM'),
            epoch: currentDateObj.format('x'),
          });
          tempDateObj = currentDateObj;
        }
      } else {
        tempDateObj = moment(content[i].created_at, 'x');
        finalContent.push({
          type: 'date-separator',
          id: `date-${tempDateObj.format('D-MMM')}`,
          date: tempDateObj.format('D MMM'),
          epoch: tempDateObj.format('x'),
        });
      }
      tempDate = content[i].created_at;
    }
    finalContent.push(content[i]);
  }
  return finalContent;
}

function concatContent(currentContent, targetContent, reverseClean) {
  if (reverseClean) {
    const targetIdList = targetContent.map((obj) => obj.id);
    const cleanList = currentContent.filter((obj) => targetIdList.indexOf(obj.id) === -1);
    return targetContent.concat(cleanList);
  }
  const currentIdList = currentContent.map((obj) => obj.id);
  const cleanList = targetContent.filter((obj) => currentIdList.indexOf(obj.id) === -1);
  return cleanList.concat(currentContent);
}

export default {
  namespaced: true,
  state: {
    logListData: {},
    logList: [],
    logDetail: {},
    availableChannel: {},
    allLogZipFileDetail: [],
    allActiveLogZipFileDetaill: [],
  },
  getters: {
    logListData: (state) => state.logListData,
    logList: (state) => state.logList,
    logDetail: (state) => state.logDetail,
    channelList: (state) => {
      if (state.availableChannel) {
        return state.availableChannel.channel;
      }
      return [];
    },
    clientList: (state) => {
      if (state.availableChannel) {
        return state.availableChannel.clientId;
      }
      return [];
    },
    allLogZipFileDetail: (state) => state.allLogZipFileDetail,
    allActiveLogZipFileDetail: (state) => state.allActiveLogZipFileDetaill,
  },
  actions: {
    loadLogList(context, params) {
      const {
        size, channel, unreadList, page, append, userSearch,
      } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadLogList(size, channel, page, userSearch)
          .then((response) => {
            const logListData = response.data.data;
            // separate list if has unread
            if (unreadList) {
              const firstArr = [];
              const afterArr = [];
              const data = logListData.userLogList;
              for (let i = 0; i < data.length; i += 1) {
                const { userId } = data[i];
                if (unreadList[userId]) {
                  firstArr.push(data[i]);
                } else {
                  afterArr.push(data[i]);
                }
              }
              // Sort unread from last update time
              firstArr.sort((a, b) => b.lastMessageAt - a.lastMessageAt);
              logListData.userLogList = firstArr.concat(afterArr);
              // console.log(firstArr, afterArr);
            }
            // Remove kan2 for test case for firsttime
            // const { logList } = context.getters;
            // if (logList.length === 0) {
            //   let targetRemIndex = -1;
            //   for (let i = 0; i < data.length; i += 1) {
            //     if (data[i].userId === 'TEST_kan2-insightera.co.th') {
            //       targetRemIndex = i;
            //       break;
            //     }
            //   }
            //   if (targetRemIndex > -1) {
            //     data.splice(targetRemIndex, 1);
            //   }
            // }
            // End Remove test
            context.commit('setLogListData', logListData);
            if (append) {
              const oldList = context.getters.logList;
              const newList = logListData.userLogList;
              const finalList = oldList.concat(newList);
              context.commit('setLogList', finalList);
              resolve(finalList);
            } else {
              context.commit('setLogList', logListData.userLogList);
              resolve(logListData.userLogList);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateLogAndMoveToTop(context, params) {
      // console.log('Update log', params);
      return new Promise((resolve, reject) => {
        const { userId, data } = params;
        const { logList } = context.getters;
        const oldList = JSON.parse(JSON.stringify(logList));
        const newList = [];
        let targetObj;
        for (let i = 0; i < oldList.length; i += 1) {
          if (oldList[i].userId === userId) {
            targetObj = oldList[i];
          } else {
            newList.push(oldList[i]);
          }
        }
        if (targetObj) {
          // Update lastMessage, lastMessageAt
          targetObj.lastMessageAt = moment(data.created_at, 'x').toISOString();
          targetObj.lastMessage = data;
          newList.unshift(targetObj);
          // console.log(newList);
          context.commit('setLogList', newList);
          // console.log('Log list updated', targetObj);
          resolve();
        } else {
          // Nothing to update - need reload
          // console.log('Update log failed');
        }
        reject();
      });
    },
    loadLogDetail(context, params) {
      const { userId, size, page } = params;
      const appendMode = params.append || false;
      return new Promise((resolve, reject) => {
        alice
          .loadLogDetail(userId, size, page)
          .then((response) => {
            const { data } = response.data;
            // Set date element for seperate content
            if (data.content) {
              data.content = data.content.reverse();
              const finalContent = extractContent(data.content);
              if (appendMode) {
                const currentDetail = context.getters.logDetail;
                const currentContent = currentDetail.content;
                data.content = concatContent(currentContent, finalContent);
              } else {
                data.content = finalContent;
              }
              context.commit('setLogDetailData', data);
            }
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    pushToLogDetail(context, arr) {
      const currentDetail = context.getters.logDetail;
      const currentContent = currentDetail.content;
      const finalContent = extractContent(arr);
      const content = concatContent(finalContent, currentContent, true);
      // console.log('NEW CONCAT', content);
      context.commit('setLogDetailContentData', content);
    },
    resetLogDetail(context) {
      context.commit('setLogDetailData', { content: [] });
    },
    loadAvailableChannel(context) {
      return new Promise((resolve, reject) => {
        alice
          .loadAvailableChannel()
          .then((response) => {
            const { data } = response.data;
            context.commit('setAvailableChannelData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadAllLogZipFileDetail(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllLogZipFileDetail()
          .then((response) => {
            const { data } = response.data;
            context.commit('setAllLogZipFileDetail', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadAllActiveLogZipFileDetail(context) {
      return new Promise((resolve, reject) => {
        alice
          .getAllActiveLogZipFileDetail()
          .then((response) => {
            const { data } = response.data;
            context.commit('setAllActiveLogZipFileDetaill', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

  },
  mutations: {
    setLogList(state, data) {
      Vue.set(state, 'logList', data);
    },
    setLogListData(state, data) {
      Vue.set(state, 'logListData', data);
    },
    setLogDetailData(state, data) {
      Vue.set(state, 'logDetail', data);
    },
    setLogDetailContentData(state, data) {
      Vue.set(state.logDetail, 'content', data);
    },
    setAvailableChannelData(state, data) {
      Vue.set(state, 'availableChannel', data);
    },
    setAllLogZipFileDetail(state, data) {
      Vue.set(state, 'allLogZipFileDetail', data);
    },
    setAllActiveLogZipFileDetaill(state, data) {
      Vue.set(state, 'allActiveLogZipFileDetaill', data);
    },
  },
};
